import { render, staticRenderFns } from "./PredictionConfigList.vue?vue&type=template&id=8571f3fa&scoped=true&"
import script from "./PredictionConfigList.vue?vue&type=script&lang=js&"
export * from "./PredictionConfigList.vue?vue&type=script&lang=js&"
import style0 from "./PredictionConfigList.vue?vue&type=style&index=0&id=8571f3fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8571f3fa",
  null
  
)

export default component.exports